import * as React from 'react';
import { Link } from 'react-router-dom';
import { isCaseViewModalEnabled, toAbsoluteUrl } from 'app/infrastructure/hosting';
import { useLocation } from 'react-router-dom';
import { getUrlOpenCase } from 'app/components/helpers';

interface TooltipCaseNumberProps {
  value: string;
}

export const TooltipCaseNumber: React.FC<TooltipCaseNumberProps> = ({ value }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  
  if(!value) {
    return null;
  }
  return (
    <Link
      to={toAbsoluteUrl(getUrlOpenCase(Number(value), currentPath, searchParams))}
      target={!isCaseViewModalEnabled() ? "_blank" : undefined}
      rel={!isCaseViewModalEnabled() ? "noopener noreferrer" : undefined}>
        {value}
    </Link>
  );
};
